// Alle Ratgeber-Artikel (neuester zuerst). Neuer Artikel = JSON-Datei hier + Eintrag in dieser Liste.
import websiteKosten from './website-kosten-schweiz.json';
import onlineTerminbuchung from './online-terminbuchung.json';
import googleProfil from './google-unternehmensprofil.json';
import websiteWartung from './website-wartung-schweiz.json';
import garageMarketing from './garage-marketing-schweiz.json';
import googleBewertungen from './google-bewertungen-sammeln.json';
import websiteRelaunch from './website-relaunch.json';
import kiAutomatisierung from './ki-automatisierung-kmu.json';
import bexioAutomatisieren from './bexio-automatisieren.json';
import wixJimdo from './wix-jimdo-oder-erstellen-lassen.json';
import emailsMitKi from './e-mails-mit-ki-beantworten.json';

export const ARTIKEL = [emailsMitKi, bexioAutomatisieren, wixJimdo, googleBewertungen, kiAutomatisierung, websiteRelaunch, garageMarketing, websiteWartung, websiteKosten, googleProfil, onlineTerminbuchung];
